import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight  } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SECURITY } from "@/lib/content";

export default function Security() {
  return (
    <div className="mx-auto max-w-7xl px-6 lg:px-14 pt-10 pb-24">
      <div className="max-w-2xl">
        <div className="overline text-cobalt-500">Security first</div>
        <h1 className="mt-2 font-display text-4xl sm:text-5xl font-black tracking-tighter">
          Built by a cybersecurity team.
        </h1>
        <p className="mt-4 text-lg text-muted-foreground leading-relaxed">
          Arventiq Labs is a cybersecurity and EdTech lab — security isn't bolted on, it's the foundation.
          Verified logins, encrypted secrets, strict per-tenant isolation, and India-first data residency.
        </p>
        <a
          href="https://arventiqlabs.com/services.html"
          target="_blank"
          rel="noreferrer"
          className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-cobalt-500 hover:underline"
        >
          Explore our security services <ArrowUpRight className="h-4 w-4" />
        </a>
      </div>

      <div className="mt-10 grid sm:grid-cols-2 gap-5">
        {SECURITY.map((s, i) => {
          const Icon = s.icon;
          return (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: (i % 2) * 0.05 }}
              className="glass rounded-2xl p-6 relative overflow-hidden group"
            >
              <div className="absolute -top-10 -right-10 h-28 w-28 rounded-full bg-cobalt-500/10 blur-2xl opacity-60" />
              <div className="relative">
                <div className="flex items-center gap-2">
                  <div className="h-9 w-9 rounded-xl bg-cobalt-500/10 text-cobalt-500 grid place-items-center">
                    <Icon className="h-4 w-4" />
                  </div>
                  <span className="font-display text-lg font-extrabold tracking-tighter">{s.label}</span>
                </div>
                <p className="mt-3 text-sm text-foreground/90 font-medium">{s.desc}</p>
                <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{s.detail}</p>
              </div>
            </motion.div>
          );
        })}
      </div>

      <div className="mt-14 glass-strong rounded-3xl p-10 lg:p-12 text-center relative overflow-hidden">
        <div className="absolute -top-20 -left-20 h-60 w-60 rounded-full bg-chartreuse/30 blur-3xl opacity-30" />
        <div className="relative">
          <h2 className="font-display text-2xl sm:text-3xl font-black tracking-tighter">
            Have a security question before you sign up?
          </h2>
          <p className="mt-3 text-muted-foreground max-w-xl mx-auto">
            Talk to us directly — we respond within one business day.
          </p>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
            <Link to="/contact">
              <Button
                size="lg"
                className="rounded-full font-medium h-11 px-6 bg-zinc-900 hover:bg-zinc-800 dark:bg-white dark:text-zinc-900 dark:hover:bg-zinc-100"
              >
                Contact us <ArrowUpRight className="ml-1.5 h-4 w-4" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
